module.exports = __webpack_public_path__ + "static/media/1_2.bc336d2f.png";